module.exports = __webpack_public_path__ + "img/1567423028.eaa428ec.jpg";